export const DISRUPTIONS_COLUMNS = {
    Status: 'status',
    Reference: 'reference',
    Routes: 'routes',
    Location: 'location',
    Diversion: 'diversion',
    DisruptionType: 'disruptionType',
    NmccInformed: 'nmccInformed',
    Delay: 'delay',
    Start: 'start',
    End: 'end',
    Actions: 'actions',
} as const

export const MANDATORY_DISRUPTION_FIELDS = {
    Location: 'location',
    Details: 'details',
    Start: 'start',
} as const
